import { ProfileColor } from "../ProfileColor";
import { DataHeader, DataSource, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPartialShipmentPlanningProfile extends Layout {
    dataheaderManifiestProfile: DataHeader;
    layoutProfileColor: ProfileColor;
    panelHierarchyLevel: Panel;
    sourceManifestProfile: DataSource;
    switchAvailableManifests: Switch;
    switchInProgressManifests: Switch;
    switchShellManifest: Switch;
    switchT: Switch;
    switchUseDistanceServer: Switch;
    tabAvailableOrders: Tab;
    tabGeneral: Tab;
    tabManifest: Tab;
    tabsetManifestProfile: Tabset;
    textboxDaysOutAvailableOrders: Textbox;
    textboxDaysOutManifest: Textbox;
    textboxDescription: Textbox;
    textboxInBoundToManifest: Textbox;
    textboxInBoundToOrders: Textbox;
    textboxInboundToLookupManifest: Textbox;
    textboxInboundToLookupOrders: Textbox;
    textboxManifestProfileId: Textbox;
    textboxOrderResponsibilityLevel: Textbox;
    textboxOutBoundFromManifest: Textbox;
    textboxOutBoundFromOrders: Textbox;
    textboxOutboundFromLookupManifest: Textbox;
    textboxOutboundFromLookupOrders: Textbox;
    textboxResponsibilityCodes: Textbox;
    textboxRevenueCode: Textbox;
}
